import { useEffect, useState } from 'react';

function Loader() {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setLoading(document.body.classList.contains('loading-indicator'));
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);

    if (!loading) return null;

    return (
        <div className="loader-overlay">
            <div className="loader-spinner" />
        </div>
    );
}

export default Loader;
